import Modal from './Modal.jsx'
import { ModalContentWrapper } from './baseModal'

export default Modal
export { ModalContentWrapper }
